import { Observable } from 'rxjs';
import {
    AccountSelectors,
    ClubActions,
    CoreActions,
    getObfClientLoadedSubscription,
    ModalsService,
    ModulesSelectors,
    SosLoaderService,
} from '@serviceos-ng/core';
import { ChangeDetectorRef, Component } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { tap, finalize } from 'rxjs/operators';
import { ClubCancelModalComponent } from '../club-cancel-modal/club-cancel-modal.component';

declare global {
    interface Window {
        obfClientSDK: any;
        obfOptions: any;
    }
}

@Component({
    selector: 'serviceos-web-club-stats',
    templateUrl: './club-stats.component.html',
    styleUrls: ['./club-stats.component.scss'],
})
export class ClubStatsComponent {
    // TODO fix error for change after init value with combine all selectors !!!
    @Select(AccountSelectors.account)
    account$!: Observable<any>;

    membership$!: Observable<any>;

    public componentConfig: any;

    view: 'purchase' | 'cancel' | 'renew' = "purchase";
    cancellationInProgress = false;

    constructor(
        private store: Store,
        private modalsService: ModalsService,
        private loaderService: SosLoaderService,
        private cdr:ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        const loader = this.loaderService.showLoader();
        
        this.store.dispatch(new CoreActions.GetSingleModule('membership', 'membership'))
        .pipe(
            finalize(() => {
                this.componentConfig = this.store.selectSnapshot(
                    ModulesSelectors.getComponentFromModule(
                    'membership',
                    'membership_status'
                ));

                this.loaderService.hideLoader(loader);
            })
        ).subscribe();
        
        this.membership$ = this.store.select(AccountSelectors.membership).pipe(
            tap((membership) => {
                this.cancellationInProgress =
                    membership?.cancellation_requested || false;

                if (membership == null) {
                    this.view = 'purchase';
                }

                if (membership?.auto_renew_enabled) {
                    this.view = 'cancel';
                }

                if (membership && !membership.auto_renew_enabled) {
                    this.view = 'renew';
                }

                this.cdr.detectChanges();
            })
        );
    }

    cancelMembership() {
        if (!this.cancellationInProgress) {
            const loader = this.loaderService.showLoader();
            this.store
                .dispatch(new ClubActions.FetchCancelReasons())
                .pipe(
                    finalize(() => {
                        this.loaderService.hideLoader(loader);
                    })
                )
                .subscribe(() => {
                    this.modalsService.open(ClubCancelModalComponent, {
                        type: 'sidebar',
                    });
                });
        }
    }

    purchaseMembership() {
        const membershipConfig = this.store.selectSnapshot(
            ModulesSelectors.getModuleByName('membership')
        );
        if (membershipConfig.settings.membership_id) {
            const loader = this.loaderService.showLoader();
            // Make sure OBF ClientJS has been loaded
            const obfClientLoadedSubscription = getObfClientLoadedSubscription()
                .pipe(
                    finalize(() => {
                        this.loaderService.hideLoader(loader);
                    })
                )
                .subscribe(
                    () => {
                        window.obfOptions.default_service_id = membershipConfig.settings.membership_id;

                        window.obfClientSDK.obfInstanceFunctions.openObf({});

                        obfClientLoadedSubscription?.unsubscribe();
                    },
                    (error) => {
                        throw new Error('Fail to start membership purchase.');
                    }
                );
        }
    }
}
